import { get, writable } from 'svelte/store';
import { CustomerService } from '../../services/customer.service';
export const loading = writable(false);
export const uploading = writable(false);
export const newLogo = writable(false);
export const records = writable([]);
export async function initList(customerId) {
    uploading.set(false);
    newLogo.set(false);
    await load(customerId);
}
export async function load(customerId) {
    loading.set(true);
    try {
        let _resp = await CustomerService.getCustomerLogotypes(customerId);
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate(customerId) {
    newLogo.set(true);
}
export function onEdit(item) {
    // not implemented
}
export async function save() {
    // not implemented
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await CustomerService.deleteCustomerLogotype(item.oid);
    await load(item.customerId);
}
export async function uploadLogotype(customerId, event) {
    uploading.set(true);
    try {
        const file = event.detail;
        let _res = await CustomerService.uploadCustomerLogotype(customerId, file);
        let fileId = _res.payload.oid;
        await load(customerId);
    }
    finally {
        uploading.set(false);
        newLogo.set(false);
    }
}
export async function onDownloadLogotype(item) {
    CustomerService.downloadCustomerLogotype(item.oid);
}
